var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "auth-bootstrap"
  }, [_c('div', {
    staticClass: "auth-bootstrap-card"
  }, [_c('h4', [_vm._v("Preparing Ops Fleet Session")]), _c('p', [_vm._v("Loading your permissions...")])])]);

}]

export { render, staticRenderFns }